import Api from "../../config/api";
import {
  CREATE_TODO,
  SEARCH_TODO,
  SEARCH_TODO_BY_ID,
  UPDATE_TODO,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getTodo = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_TODO, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getTodoById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_TODO_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createTodo = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_TODO, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateTodo = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_TODO}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
